import ForgotPassword from '../../cast/castForgotPassword/forgotPassword';

export default function CustomerForgotPassword() {
  return <ForgotPassword isUser={true} />;
}
